module.exports = __webpack_public_path__ + "img/rebackCarding.76b41d90.png";